import React from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div class="page-padding-info">
            <div class="text-page-container">
            <h1 class="text-page-title">{t("privacyPolicy.title")}</h1>

            <strong>{t("privacyPolicy.introTitle")}</strong>
            <p>
                {t("privacyPolicy.intro")}
            </p>
            <p>
                {t("privacyPolicy.lead")}
            </p>

            <strong>{t("privacyPolicy.whyTitle")}</strong>
            <p>
                {t("privacyPolicy.why")}
            </p>

            <strong>{t("privacyPolicy.whatTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.what" components={{ 1: <strong /> }} />
            </p>

            <strong>{t("privacyPolicy.whenTitle")}</strong>
            <p>
                {t("privacyPolicy.when")}
            </p>
            <ul>
                <li>
                    <p>
                        <strong>
                            {t("privacyPolicy.duringCreationTitle")} : 
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.duringCreation")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                            {t("privacyPolicy.whenOrderPlacedTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.whenOrderPlaced")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.duringSupportTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.duringSupport")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.websiteUsageTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.websiteUsage")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.marketingSignupTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.marketingSignup")}
                    </p>
                </li>
            </ul>
            
            <strong>{t("privacyPolicy.howDataUsedTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.howDataUsed" components={{ 1: <strong /> }} />
            </p>

            <strong>{t("privacyPolicy.whoAccessDataTitle")}</strong>
            <p>
                {t("privacyPolicy.whoAccessData")}
            </p>

            <strong>{t("privacyPolicy.whichDataSharedTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.whichDataShared" components={{ 1: <strong /> }} />
            </p>
            <ul>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.mailingServiceTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.mailingService")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.paymentProviderTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.paymentProvider")}
                    </p>
                </li>
                <li>
                    <p>
                        <strong>
                        {t("privacyPolicy.emailProviderTitle")} :
                        </strong>
                        &nbsp;
                        {t("privacyPolicy.emailProvider")}
                    </p>
                </li>
            </ul>
            <p>
            <strong>{t("privacyPolicy.noSellTitle")}</strong> 
            {t("privacyPolicy.noSell")}
            </p>

            <strong>{t("privacyPolicy.timeKeptTitle")}</strong>
            <p>
            {t("privacyPolicy.timeKept")}
            </p>

            <strong>{t("privacyPolicy.howProtectTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.howProtect" components={{ 1: <strong /> }} />
            </p>

            <strong>{t("privacyPolicy.cookiesTrackingTitle")}</strong>
            <p>
            {t("privacyPolicy.cookiesTracking")}
            </p>

            <strong>{t("privacyPolicy.yourRightsTitle")}</strong>
            <p>
            {t("privacyPolicy.yourRights")}
            </p>

            <strong>{t("privacyPolicy.contactTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.contact" components={{ 1: <a href="mailto:contact@awootoys.com" /> }} />
            </p>

            <br/>
            <strong>{t("privacyPolicy.ourAddressTitle")}</strong>
            <p>
                <Trans i18nKey="privacyPolicy.ourAddress" components={{ 1: <a href="mailto:contact@awootoys.com" />, 2: <br />, 3: <strong /> }} />
            </p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;